import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  overflow-x: auto;
  padding-bottom: 8px;
`;

export const ItemWrapper = styled.div<{ $isActive: boolean }>`
  display: inline-flex;
  max-height: 24px;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  border-radius: 4px;
  cursor: pointer;
  border: ${({ $isActive, theme }) =>
    $isActive ? `1px solid ${theme.colors.green7}` : `1px solid ${theme.colors.black4}`};
  background: ${({ $isActive, theme }) => ($isActive ? theme.colors.green2 : 'transparent')};
  flex-shrink: 0;

  :hover {
    background: ${({ theme }) => theme.colors.green1};
  }
`;
